import * as React from 'react';
import type { fetchVisitPortalModel } from 'state/actions/invited-sign-up';
import { withErrorPage } from '@atlassian/help-center-common-component/error-page';
import type { DefaultError } from '@atlassian/help-center-common-util/errors';
import Redirect from '@atlassian/help-center-common-util/redirect';

import {
    getLoginUrlForPortalIdAsString,
    getPortalUrlWithPortalIdAsString,
} from '@atlassian/help-center-common-util/url';
import { InvitedSignUpStateless } from './invited-sign-up-stateless';
import { retrieveUrlParams } from './invited-sign-up-url-param-retriever';

interface InvitedSignUpProps {
    loggedInBeforeCheck: boolean;
    isFailedLoginAttempt: boolean;
    portalId: string;
    email: string;
    isLoading: boolean;
    isLoggedIn: boolean;
    contactLink: string;
    submitError?: DefaultError;
    fetchVisitPortalModelAction: typeof fetchVisitPortalModel;
    helpCenterName: string;
}

export class InvitedSignUp extends React.Component<InvitedSignUpProps> {
    componentDidMount() {
        const { isLoading, portalId } = this.props;
        if (isLoading) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const { token, appUserId, username } = retrieveUrlParams();
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.props.fetchVisitPortalModelAction({ appUserId, username, token, portalId: Number(portalId) });
        }
    }

    render() {
        const {
            contactLink,
            submitError,
            helpCenterName,
            isLoading,
            portalId,
            email,
            isLoggedIn,
            loggedInBeforeCheck,
            isFailedLoginAttempt,
        } = this.props;
        if (isLoggedIn) {
            return <Redirect to={getPortalUrlWithPortalIdAsString(portalId)} />;
        }

        if (loggedInBeforeCheck || isFailedLoginAttempt) {
            return <Redirect to={getLoginUrlForPortalIdAsString(portalId)} />;
        }

        return (
            <InvitedSignUpStateless
                submitError={submitError}
                contactLink={contactLink}
                helpCenterName={helpCenterName}
                email={email}
                isLoading={isLoading}
            />
        );
    }
}

export default withErrorPage(InvitedSignUp);
